"use strict";function stopRecord$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.stopRecord$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.audio.stopRecord";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.8.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.8.0"},_a)),exports.stopRecord$=stopRecord$,exports.default=stopRecord$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/audio/stopRecord.js
// module id = 1049
// module chunks = 106